var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useMemo, useState } from "react";
import { observer } from "mobx-react";
import Highlighter from "react-highlight-words";
import { Button, List, QueryParameters, StackLayout, TextInput, useGuid, Text, Checkbox, } from "@wemogy/reactbase";
import SearchAndReplaceStore from "../dataLayer/stores/SearchAndReplaceStore";
var SearchAndReplace = function (_a) {
    var dataAccessStore = _a.dataAccessStore, propertyName = _a.propertyName, humanizeSearchResultIdentifier = _a.humanizeSearchResultIdentifier, replaceCallback = _a.replaceCallback, customPatchHandler = _a.customPatchHandler;
    var searchAndReplaceQueryKey = useGuid("searchAndReplace");
    var _b = __read(useState(SearchAndReplaceStore.create()), 1), searchAndReplaceStore = _b[0];
    var _c = __read(useState(0), 2), totalReplace = _c[0], setTotalReplace = _c[1];
    var _d = __read(useState(0), 2), currentReplace = _d[0], setCurrentReplace = _d[1];
    var handleSearchPress = useCallback(function () {
        dataAccessStore.putStoredQuery(searchAndReplaceQueryKey, QueryParameters.create()
            .putFilter(propertyName, searchAndReplaceStore.searchQuery, searchAndReplaceStore.replaceIgnoreCase
            ? "containsIgnoreCase"
            : "contains")
            .withoutTake(), true);
    }, [
        dataAccessStore,
        searchAndReplaceQueryKey,
        searchAndReplaceStore.searchQuery,
    ]);
    var itemRenderer = useMemo(function () { return function (item) {
        return (React.createElement(StackLayout, { marginBottom: true },
            React.createElement(Text, { noTranslation: true, fontWeight: { custom: 600 } }, humanizeSearchResultIdentifier(item)),
            React.createElement(StackLayout, { marginTopBottom: true },
                React.createElement(Highlighter, { caseSensitive: !searchAndReplaceStore.replaceIgnoreCase, highlightClassName: "YourHighlightClass", searchWords: [searchAndReplaceStore.searchQuery], autoEscape: true, textToHighlight: searchAndReplaceStore.getSearchResultValue(propertyName, item) })),
            React.createElement(Button, { onPress: function () {
                    setCurrentReplace(1);
                    setTotalReplace(1);
                    searchAndReplaceStore.replace(dataAccessStore, item, propertyName, replaceCallback, customPatchHandler);
                } }, "Replace")));
    }; }, [
        dataAccessStore,
        searchAndReplaceStore.searchQuery,
        replaceCallback,
        propertyName,
    ]);
    var searchResults = dataAccessStore.queryItems(searchAndReplaceQueryKey);
    var handleReplaceAllPress = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var i, item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setTotalReplace(searchResults.length);
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < searchResults.length)) return [3 /*break*/, 4];
                    item = searchResults[i];
                    setCurrentReplace(i + 1);
                    return [4 /*yield*/, searchAndReplaceStore.replace(dataAccessStore, item, propertyName, replaceCallback, customPatchHandler)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [searchResults, dataAccessStore, replaceCallback]);
    var handleReplaceCompletePropertyChecked = useCallback(function (checked) {
        searchAndReplaceStore.setReplaceCompleteProperty(checked);
    }, [searchAndReplaceStore]);
    var handleReplaceIgnoreCaseChecked = useCallback(function (checked) {
        searchAndReplaceStore.setReplaceIgnoreCase(checked);
    }, [searchAndReplaceStore]);
    if (searchAndReplaceStore.isReplacing) {
        return (React.createElement(StackLayout, { stretch: true, hCenter: true, vCenter: true },
            React.createElement(Text, { noTranslation: true }, "Replacing: " + currentReplace + "/" + totalReplace)));
    }
    return (React.createElement(StackLayout, { stretch: true },
        React.createElement(StackLayout, { orientation: "horizontal", marginBottom: true },
            React.createElement(TextInput, { placeholder: "search", onChange: searchAndReplaceStore.setSearchQuery, value: searchAndReplaceStore.searchQuery }),
            React.createElement(StackLayout, { marginTopBottom: true },
                React.createElement(Checkbox, { checked: searchAndReplaceStore.replaceCompleteProperty, onChange: handleReplaceCompletePropertyChecked, label: "Komplettes Feld ersetzen", marginBottom: true }),
                React.createElement(Checkbox, { checked: searchAndReplaceStore.replaceIgnoreCase, onChange: handleReplaceIgnoreCaseChecked, label: "Gro\u00DF- und Kleinschreibung ignorieren" })),
            React.createElement(Button, { marginLeft: true, onPress: handleSearchPress }, "Search")),
        searchResults.length ? (React.createElement(React.Fragment, null,
            React.createElement(TextInput, { maxHeight: 4, placeholder: "Replace", onChange: searchAndReplaceStore.setReplaceValue, value: searchAndReplaceStore.replaceValue, marginBottom: true }),
            React.createElement(Button, { marginBottom: true, onPress: handleReplaceAllPress }, "Alle " + searchResults.length + " ersetzen"))) : null,
        React.createElement(StackLayout, { stretch: true },
            React.createElement(List, { itemRenderer: itemRenderer, itemHeight: function () { return 12; }, items: searchResults }))));
};
export default observer(SearchAndReplace);
//# sourceMappingURL=SearchAndReplace.js.map